import { gql } from "@apollo/client";

const LOGIN_MUTATION = gql`
  mutation login($userInput: LoginUserInput!) {
    login(userInput: $userInput) {
      id
      username
      accessToken
      isBroadcaster
      broadcaster
      cbUsername
      discordTokens
    }
  }
`;

export const REGISTER_USER = gql`
  mutation registerUser($userInput: RegisterUserInput) {
    registerUser(userInput: $userInput) {
      username
      accessToken
    }
  }
`;

export const GET_USER_DATA = gql`
  query getUserData {
    getUserData {
      id
      username
      accessToken
      isBroadcaster
      broadcaster
      cbUsername
      discordTokens
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation RefreshToken {
    refreshToken
  }
`;

export const LOGOUT = gql`
  mutation logout {
    logout
  }
`;

export const GET_TOP_FIVE_USERS = gql`
  query getLeaderBoardTippers {
    getLeaderBoardTippers {
      username
      currentTips
      inFanClub
      broadcaster
    }
  }
`;

export const SEND_FORGOT_PASSWORD_TOKEN = gql`
  mutation Mutation($username: String!) {
    sendForgotPasswordToken(username: $username)
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResetPassword($resetPasswordInput: ResetPasswordInput) {
    resetPassword(resetPasswordInput: $resetPasswordInput)
  }
`;

export default LOGIN_MUTATION;
